import { Flex, Grid, SectionTitle, Text } from '@shared/components';

import { useQSetReviewSubtask } from '../../providers';
import {
  formatExamQuestionType,
  formatQuestionCalculationTags,
  formatQuestionDifficultyTags,
} from '../../utils';

export default function QConfigDetails() {
  const { subtaskDetails } = useQSetReviewSubtask();
  const { qSet, examCourse } = subtaskDetails;
  const { code, qConfig, conditions } = qSet;
  const averagePValue = conditions?.averagePValue;
  const { fullScore, totalQuestions } = qConfig;
  const { tags, questionTypes } = conditions ?? {};

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column' })}>
      <SectionTitle title='ข้อมูลชุดข้อสอบ' />
      <Grid
        sx={(theme) => ({
          gridTemplateColumns: `160px 1fr`,
          gap: theme.spacing(4, 6),
          '.MuiTypography-root:nth-of-type(odd)': {
            fontWeight: theme.typography.body2Semibold.fontWeight,
          },
          '.MuiTypography-root:nth-of-type(even)': {
            wordBreak: 'break-word',
          },
          fontSize: theme.typography.body2.fontSize,
        })}
      >
        <Text>QSet ID</Text>
        <Text>{code}</Text>
        <Text>หลักสูตรทดสอบ</Text>
        <Text>{examCourse.name}</Text>
        <Text>จำนวนข้อสอบทั้งหมด</Text>
        <Text>{totalQuestions ?? '-'} ข้อ</Text>
        <Text>คะแนนรวม</Text>
        <Text>{fullScore ?? '-'} คะแนน</Text>
        <Text>ประเภทคำถาม</Text>
        <Text>{questionTypes ? formatExamQuestionType(questionTypes) : '-'}</Text>
        <Text>ประเภทข้อสอบ</Text>
        <Text>{tags ? formatQuestionCalculationTags(tags) : '-'}</Text>
        <Text>ระดับความยาก</Text>
        <Text>{tags ? formatQuestionDifficultyTags(tags) : '-'}</Text>
        <Text>ค่า P Average</Text>
        <Text>{averagePValue ? averagePValue.toFixed(2) : '-'}</Text>
      </Grid>
    </Flex>
  );
}
